import { Typography } from 'antd';
import styled from 'styled-components';

import { NeutralColors } from '@/theme';

export const Container = styled.div`
  display: flex;
  flex: 1;
  flex-direction: column;
  box-shadow: ${props => props.theme.boxShadow};
  border-radius: ${props => props.theme.borderRadius}px;
  padding: 16px;
  background-color: ${NeutralColors[0]};
`;

export const Content = styled.div`
  display: flex;
  flex: 1;
  flex-direction: column;
`;

export const Title = styled(Typography.Text)`
  margin-bottom: 8px;
  font-size: 16px;
  font-weight: 600;
`;
